import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 *
 * Simple editor
 */
export function ListEditorDefaultEditor(_ref) {
  let {
    data,
    onSuccess,
    onDismiss
  } = _ref;
  //simple example -
  const [formState, setFormState] = React.useState(data);
  function onUpdate(updated) {
    setFormState(updated);
  }
  function onSave() {
    if (formState) {
      onSuccess(formState);
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [
      //no data means create....
      !data && /*#__PURE__*/_jsx("button", {
        onClick: () => onSave(),
        children: "add"
      }), /*#__PURE__*/_jsx("button", {
        onClick: () => onDismiss && onDismiss(),
        children: "cancel"
      })]
    }), /*#__PURE__*/_jsx("textarea", {
      name: "val",
      id: "val",
      onChange: event => {
        try {
          const updated = JSON.parse(event.target.value);
          onUpdate(updated);
          if (data) {
            onSave();
          }
        } catch (_unused) {}
      },
      value: JSON.stringify(formState)
    }, "val")]
  });
}